import { RadioButton, DropDown } from '../components'
import { useContext, useState } from "react"
import { catPlan, catCoveragesName, catSumInsuredColones, catSumInsuredDolar } from '../data/MochaData'
import { DataContext } from "../data/DataContext"
import { IconCheck } from '../img'
import { roundToTwo } from '../../../utils/helpMain'



const StepPlans = () => {
    const { IHContenidoSeguroCR, SetIHContenidoSeguroCR, ChangeHandler, ChangeHandler2 } = useContext(DataContext);

    const GetNameCoverage = (id: number) => catCoveragesName.find(x => x.value == id.toString())?.text;

    const GetSum = (index: number) => IHContenidoSeguroCR.plan === '595' ? catSumInsuredDolar[index].text : catSumInsuredColones[index].text

    const GetPlanHire = () => {
        if (IHContenidoSeguroCR.plan === '594')
            return catSumInsuredColones.map((x, i) => { return { value: (i + 1).toString(), text: `Plan ${i + 1} ` } as ICatalog })
        else if (IHContenidoSeguroCR.plan === '595')
            return catSumInsuredDolar.map((x, i) => { return { value: (i + 1).toString(), text: `Plan ${i + 1} ` } as ICatalog })
        return []
    }

    const ChangePlanSelected = (prop: string, value: any) => {
        const planSelected = IHContenidoSeguroCR.lstRateResumen[parseInt(value) - 1]
        if(planSelected === undefined) return;
        let fees = roundToTwo(planSelected.total / parseInt(IHContenidoSeguroCR.nQuotas)).toString()      
        SetIHContenidoSeguroCR({ ...IHContenidoSeguroCR, feePay: fees, [prop]: value })
    }

    return (
        <>
            <RadioButton
                field='plan'
                label='Moneda'
                value={IHContenidoSeguroCR.plan}
                onChange={() => { }}
                catalog={catPlan}
                onChangeStr={ChangeHandler2}
            />
            <DropDown
                dataProvider={IHContenidoSeguroCR.catQuotas}
                field='nQuotas'
                label='Frecuencia de pago'
                valueSelect={IHContenidoSeguroCR.nQuotas}
                onChangeSelect={ChangeHandler2}
            />

            {IHContenidoSeguroCR.lstRateResumen.map((x, index) => {
                return (
                    <div key={index} style={{ display: 'flex', justifyContent: 'center' }} >
                        <div className="card-ih-contenido-cr mt-20">
                            <div className="card-header-ih-contenido-cr" style={{ borderBottom: '1px', borderColor: '#00583C' }}>
                                <div className="plan-ih-contenido-cr">Plan {index + 1}</div>
                                <div className="" style={{ color: '#00583C', fontSize: '20px', fontWeight: 600 }}>{GetSum(index)}</div>

                            </div>
                            <table className="mb-10" >
                                <thead style={{ textAlign: 'left' }}>
                                    <tr>
                                        <th style={{ width: '60%', color: '#00583C', padding: 0, fontSize: '14px', fontWeight: 500 }} colSpan={2}>Cobertura</th>
                                        <th style={{ color: '#00583C', padding: 0, fontSize: '14px', fontWeight: 500 }}>Suma Asegurada</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr></tr>
                                    {x.coveragesDetail.sort((x: IRatesTable, y: IRatesTable) => ((x.idcob ?? 0) - (y.idcob ?? 0))).map(x => {
                                        return (
                                            <tr  key={x.idcob ?? Math.random()} style={{ color: '#00583C', padding: 0, fontSize: '15px' }}>
                                                <td><IconCheck /></td>
                                                <td >{GetNameCoverage(x.idcob ?? 0)}</td>
                                                <td style={{ color: '#00583C', fontWeight: 500 }}>{x.value}</td>
                                            </tr>
                                        )
                                    })}
                                    <tr style={{ color: '#00583C', padding: 0, fontSize: '15px' }}>
                                        <td colSpan={3} style={{ textAlign: 'center' }}>Prima por plan {x.bonusFrecuenciaStr}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                )
            })}


            <div className="mt-20 mb-10" >
                <label style={{ color: '#4D4D4D', fontSize: '20px', fontWeight: 500 }}>Seleccione el plan de su preferencia</label>
            </div>
            <DropDown
                dataProvider={GetPlanHire()}
                field='planSelected'
                label='Plan a contratar'
                valueSelect={IHContenidoSeguroCR.planSelected}
                onChangeSelect={ChangePlanSelected}
            />

        </>
    )
}

export { StepPlans }